import { useEffect } from 'react'

const canScroll = (el: HTMLElement, dy: number) => {
    if (el.scrollHeight <= el.clientHeight || getComputedStyle(el).overflowY === 'visible') return false
    return dy > 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight
}

// iOS ignores overflow: hidden and overscroll-behavior for a touch that started on top of a scroller: while `active`,
// only a scroller inside `scopeSelector` that can still move in that direction takes a touch, the page behind does not
const useTouchScrollLock = (active: boolean, scopeSelector: string) => {
    useEffect(() => {
        if (!active) return

        let startY = 0
        const onTouchStart = (e: TouchEvent) => {
            startY = e.touches[0].clientY
        }
        const onTouchMove = (e: TouchEvent) => {
            const dy = e.touches[0].clientY - startY
            const target = e.target instanceof HTMLElement ? e.target : null
            const scope = target?.closest<HTMLElement>(scopeSelector)
            for (let el = target; scope && el; el = el.parentElement) {
                if (canScroll(el, dy)) return
                if (el === scope) break
            }
            e.preventDefault()
        }
        document.addEventListener('touchstart', onTouchStart, { passive: true })
        document.addEventListener('touchmove', onTouchMove, { passive: false })

        return () => {
            document.removeEventListener('touchstart', onTouchStart)
            document.removeEventListener('touchmove', onTouchMove)
        }
    }, [active, scopeSelector])
}

export default useTouchScrollLock
